@if (!userService.isLoggedIn()) {
  <div class="button-bar">
    <a
      [routerLink]="['/login']"
      class="button"
      i18n="Product detail: log in@@product.detail.login"
      >
      Log in to view prices
    </a>
  </div>
  <p>
    <span i18n="Product detail: login pre text@@product.detail.login.pre.text"
      >Log in or</span
      >
      <a
        href="{{ applicationService.getRegisterUrl() }}"
        i18n="Product detail: login link text@@product.detail.login.link.text"
        >become a customer of Noviflora</a
        >
        <span
          i18n="Product detail: login suffix text@@product.detail.login.suffix.text"
          >
      to view the latest prices of our products
    </span>
      </p>
    }

    @if (userService.isLoggedIn()) {
      <product-favorite [product]="productDetail"></product-favorite>
      <!-- Only render the price if it's set -->
      @if (productDetail.unitPrice || productDetail.unitDiscountPrice) {
        <!--Discount price -->
        @if (productDetail.saleDiscount > 0) {
          <s class="product-detail original-price">
            {{ applicationService.getUserCurrency() }}
            {{
            productPrices.getOriginalPriceForProductType() | number: "1.2-2"
            }}</s
            >
            <h2 class="product-detail_price">
              {{ applicationService.getUserCurrency() }}
              {{ productPrices.getCheapestAvailablePrice() | number: "1.2-2" }}
              <span class="discount-tag theme-success-color"
                >-{{ productDetail.saleDiscount }}%</span
                >
              </h2>
            }
            <!-- Normal, non-discount -->
            @if (productDetail.saleDiscount == 0) {
              <h2 class="product-detail_price">
                {{ applicationService.getUserCurrency() }}
                {{ productPrices.getCheapestAvailablePrice() | number: "1.2-2" }}
              </h2>
            }
            <p class="product-detail_notice">
              @if (isStockProduct() && productDetail.qtyByBox >= 1) {
                <strong
                  class="text-green-notice theme-success-text-color"
                  i18n="product detail: units available@@product.quantity.stock.unit"
                  >
        {{ getAvailableQuantity() }} x{{ productDetail.qtyByBox }} available
      </strong>
              }
              @if (isProductSoldOut()) {
                <strong
                  class="text-red-notice"
                  i18n="product detail: not available@@product.not.available"
                  >
        Product not available
      </strong>
              }
            </p>
          }
          @if (productDetail.available && !isProductSoldOut()) {
            <buy-options
              [disabled]="isProductSoldOut()"
              [product]="productDetail"
            ></buy-options>
          } @else {
            <h2
              class="product-detail_price"
      i18n="
        Not available text in product tile
        view@@productitem.grid.currently.unavailable"
              >
      Currently unavailable
    </h2>
            <p style="margin-bottom: 0">&nbsp;</p>
            @if (productDetail.firstAvailableDate) {
              <p>
                <span
                  i18n="product detail: not available@@product.expected.available.from"
                  >This product is expected to be available again on:</span
                  ><br />
                  <strong>{{
                    productDetail.firstAvailableDate | customDate: "dd-MM-yyyy"
                  }}</strong>
                </p>
              }
              <p i18n="product detail: check alternatives@@product.check.alternatives">
      View alternative products below.
    </p>
            }
            <p>&nbsp;</p>
            @if (activeLine && activeLine.qtyByBox == 1) {
              <p
                class="product-detail_notice"
                >
                <strong
                  class="text-green-notice theme-success-text-color"
                  i18n="product detail: item in active order@@product.in.active.order.unit"
                  >
      This item is in your active order {{ getQuantity() }} x Unit
    </strong>
              </p>
            }
            @if (activeLine && activeLine.qtyByBox > 1) {
              <p
                class="product-detail_notice"
                >
                <strong
                  class="text-green-notice theme-success-text-color"
                  i18n="product detail: item in active order@@product.in.active.order.tray"
                  >
      This item is in your active order {{ getQuantity() }} x
      {{ activeLine.qtyByBox }}
    </strong>
              </p>
            }
          }
